import { Modal } from '@/shared/components/ui/Modal'
import type { AssetHolding } from '@/modules/inventory/holdings'
import {
  BatchAdjustmentForm,
  type BatchAdjustmentFormData,
} from './BatchAdjustmentForm'

interface BatchAdjustmentDialogProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
  title: string
  submitLabel: string
  unitId: string
  batch: AssetHolding | null
  formData: BatchAdjustmentFormData
  setFormData: (data: BatchAdjustmentFormData) => void
  formErrors: Record<string, string>
  submitting: boolean
  error?: string | null
  tc?: (key: string) => string
}

export function BatchAdjustmentModal({
  isOpen,
  onClose,
  onSubmit,
  title,
  submitLabel,
  unitId,
  batch,
  formData,
  setFormData,
  formErrors,
  submitting,
  error,
  tc,
}: BatchAdjustmentDialogProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      onSubmit={onSubmit}
      submitLabel={submitLabel}
      submitting={submitting}
    >
      <div className="space-y-4">
        {error && (
          <div className="p-3 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400 text-sm">
            {error}
          </div>
        )}

        <BatchAdjustmentForm
          batch={batch}
          formData={formData}
          setFormData={setFormData}
          formErrors={formErrors}
          submitting={submitting}
          tc={tc}
        />
      </div>
    </Modal>
  )
}
